import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  useTheme
} from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat
} from '@mui/icons-material';

const StatCard = ({ 
  icon, 
  title, 
  value, 
  trend, 
  color = 'primary',
  subtitle,
  loading = false 
}) => {
  const theme = useTheme();

  const getTrendIcon = () => {
    if (!trend) return null;
    
    if (trend.includes('+') || trend.includes('↑')) {
      return <TrendingUp sx={{ fontSize: 16, color: theme.palette.success.main }} />;
    } else if (trend.includes('-') || trend.includes('↓')) {
      return <TrendingDown sx={{ fontSize: 16, color: theme.palette.error.main }} />;
    } else {
      return <TrendingFlat sx={{ fontSize: 16, color: theme.palette.grey[500] }} />;
    }
  };

  const getTrendColor = () => {
    if (!trend) return 'default';
    
    if (trend.includes('+') || trend.includes('↑')) {
      return 'success';
    } else if (trend.includes('-') || trend.includes('↓')) {
      return 'error';
    } else {
      return 'default';
    }
  };

  return (
    <Card 
      sx={{ 
        height: '100%',
        position: 'relative',
        overflow: 'visible',
        '&:hover': {
          transform: 'translateY(-4px)',
          transition: 'all 0.3s ease-in-out',
        }
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              backgroundColor: `${theme.palette[color].main}15`,
              color: theme.palette[color].main,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
          
          {trend && (
            <Chip
              icon={getTrendIcon()}
              label={trend}
              size="small"
              color={getTrendColor()}
              variant="outlined"
              sx={{ 
                fontSize: '0.75rem',
                height: 24,
                '& .MuiChip-icon': {
                  fontSize: 14,
                }
              }}
            />
          )}
        </Box>

        <Typography 
          variant="h4" 
          component="div" 
          sx={{ 
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 0.5,
            fontSize: { xs: '1.5rem', sm: '2rem' }
          }}
        >
          {loading ? '...' : value}
        </Typography>

        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: 1.4
          }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ 
              display: 'block',
              mt: 1,
              fontSize: '0.75rem'
            }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
